// Motif tokens — keep in sync with /app/design_guidelines.json
export const MOTIFS = {
  "Ivory & Gold": {
    primary: "#D4AF37", primary_fg: "#FFFFFF",
    bg: "#FDFBF7", surface: "#FFFFFF",
    text: "#2C2A26", muted: "#8A867D",
    border: "#EAE5D9", accent: "#F5EEDB",
    display: "'Cormorant Garamond', serif",
    body: "'Outfit', sans-serif",
  },
  "Black Tie": {
    primary: "#1A1A1A", primary_fg: "#FFFFFF",
    bg: "#FAFAFA", surface: "#FFFFFF",
    text: "#0A0A0A", muted: "#666666",
    border: "#E5E5E5", accent: "#F0F0F0",
    display: "'Cormorant Garamond', serif",
    body: "'Outfit', sans-serif",
  },
  "Floral": {
    primary: "#D49A89", primary_fg: "#FFFFFF",
    bg: "#FDF8F5", surface: "#FFFFFF",
    text: "#4A3F3B", muted: "#9C8A84",
    border: "#F2E3DF", accent: "#F9ECE8",
    display: "'Cormorant Garamond', serif",
    body: "'Outfit', sans-serif",
  },
  "South Asian Luxury": {
    primary: "#B22222", primary_fg: "#FFFFFF",
    bg: "#FFF9F5", surface: "#FFFFFF",
    text: "#3B1B1B", muted: "#8B5A5A",
    border: "#F5E1E1", accent: "#FFDF00",
    display: "'Cormorant Garamond', serif",
    body: "'Outfit', sans-serif",
  },
  "Minimal": {
    primary: "#2A2A2A", primary_fg: "#FFFFFF",
    bg: "#FFFFFF", surface: "#F9F9F9",
    text: "#111111", muted: "#888888",
    border: "#EEEEEE", accent: "#F4F4F4",
    display: "'Outfit', sans-serif",
    body: "'Outfit', sans-serif",
  },
  "Art Deco": {
    primary: "#C5A059", primary_fg: "#111111",
    bg: "#1A1A1A", surface: "#222222",
    text: "#F5F5F5", muted: "#A89F91",
    border: "#333333", accent: "#2A2A2A",
    display: "'Cormorant Garamond', serif",
    body: "'Outfit', sans-serif",
  },
};

export const MOTIF_NAMES = Object.keys(MOTIFS);

export function applyMotif(name) {
  const m = MOTIFS[name] || MOTIFS["Ivory & Gold"];
  const r = document.documentElement;
  r.style.setProperty("--motif-primary", m.primary);
  r.style.setProperty("--motif-primary-fg", m.primary_fg);
  r.style.setProperty("--motif-bg", m.bg);
  r.style.setProperty("--motif-surface", m.surface);
  r.style.setProperty("--motif-text", m.text);
  r.style.setProperty("--motif-text-muted", m.muted);
  r.style.setProperty("--motif-border", m.border);
  r.style.setProperty("--motif-accent", m.accent);
  r.style.setProperty("--motif-font-display", m.display);
  r.style.setProperty("--motif-font-body", m.body);
}
